import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Link,
  Box
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const PrivacyPolicyPage = () => {
    return (
        <>
          <Container sx={{ py: 4 }}>
            <Typography variant="h4" color="primary" gutterBottom>
              Privacy Policy
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Effective Date: September 23, 2025
            </Typography>
            <Typography paragraph>
              At CCOO.ca, your privacy matters. This Privacy Policy explains how we collect, use, and protect your information when you visit our website or interact with our brand.
            </Typography>

            <Accordion defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">🔍 Information We Collect</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography paragraph>
                  We may collect the following types of information:
                </Typography>
                <ul>
                  <li><strong>Personal Information:</strong> Name, email address (if you contact us or subscribe)</li>
                  <li><strong>Usage Data:</strong> Pages visited, time spent, device type, browser type</li>
                  <li><strong>Referral Data:</strong> If you click through to Amazon, we may track that (non-personal)</li>
                </ul>
                <Typography paragraph>
                  We do <strong>not</strong> collect payment information. All purchases are handled securely through Amazon.ca.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">🛠️ How We Use Your Information</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography paragraph>
                  We use your data to:
                </Typography>
                <ul>
                  <li>Improve website performance and user experience</li>
                  <li>Respond to inquiries or support requests</li>
                  <li>Share updates, promotions, or product launches (if you opt in)</li>
                  <li>Analyze traffic and referral patterns to Amazon</li>
                </ul>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">🔐 Data Protection</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography paragraph>
                  We take reasonable steps to protect your information:
                </Typography>
                <ul>
                  <li>Secure hosting via Firebase</li>
                  <li>HTTPS encryption across all pages</li>
                  <li>No unauthorized sharing or selling of your data</li>
                </ul>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">🍪 Cookies</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography paragraph>
                  We may use cookies or similar technologies to:
                </Typography>
                <ul>
                  <li>Track site usage</li>
                  <li>Remember preferences</li>
                  <li>Measure referral traffic to Amazon</li>
                </ul>
                <Typography paragraph>
                  You can disable cookies in your browser settings.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">🔗 Third-Party Links</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography paragraph>
                  Our site contains links to Amazon.ca and other external platforms. We are not responsible for their privacy practices. Please review their policies separately.
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">📬 Contact Us</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography paragraph>
                  If you have questions about this Privacy Policy or your data, contact us at:
                </Typography>
                <Typography>
                  <Link href="mailto:privacy@ccoo.ca">privacy@ccoo.ca</Link>
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="h6">🔄 Updates</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography paragraph>
                  We may update this policy from time to time. Changes will be posted on this page with a revised effective date.
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Container>
        </>
    )
}
export default PrivacyPolicyPage;